import React from "react";
import Map from "./Map";

const MapSection = () => (
  <section className="map-section dark-bg pb-0 pt-0">
    <Map type="2" className="wide" />
  </section>
);

export default MapSection;
